import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthModalComponent } from '@app/core/user/containers/auth-modal/auth-modal.component';
import * as reducers from '@app/core/user/store/reducers';
import { IAppState } from '@app/store';
import { select, Store } from '@ngrx/store';
import { UserService } from '@app/core/user/services/user/user.service';
import { AuthModal } from '@app/shared/model/interfaces/AuthDialog/AuthModal';
import { Credentials } from '@vestiaire/api-sdk-angular';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'vc-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit, OnDestroy {
  @Input()
  popinForced: boolean;

  public credentials: Credentials;
  public blocToShow: BehaviorSubject<'newsletter' | 'register'> = new BehaviorSubject<'newsletter' | 'register'>(
    'newsletter'
  );

  constructor(
    private dialogRef: MatDialogRef<AuthModalComponent>,
    private store: Store<IAppState>,
    private userService: UserService
  ) {}

  ngOnInit() {
    this.store.pipe(select(reducers.isAuthenticated)).subscribe(
      res => {
        if (res) {
          this.dialogRef.close();
        }
      },
      err => {
        // Silent catch error because we don't have anything to do
      }
    );

    this.userService.getAuthDialogData().subscribe(
      res => {
        if (res && res.credentials && res.credentials.email) {
          this.blocToShow.next('register');
          this.credentials = res.credentials;
        }
      },
      err => {}
    );
  }

  ngOnDestroy() {
    this.userService.setAuthDialogData(null);
  }

  public setUser(data: Credentials) {
    this.blocToShow.next('register');
    this.credentials = data;

    this.userService.setAuthDialogData({ authModalType: 'register', credentials: this.credentials } as AuthModal);
  }
}
